export const getDateFormat = () => localStorage.getItem('dateFormat')

export default { getDateFormat }
